import { render, staticRenderFns } from "./ResolvedComplaints.vue?vue&type=template&id=10b1ec5c"
import script from "./ResolvedComplaints.vue?vue&type=script&lang=js"
export * from "./ResolvedComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports